import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/admin/adminLogin.css";

function IconMail() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconLock() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" strokeLinecap="round" />
    </svg>
  );
}

function IconEyeOff() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M3 3l18 18" strokeLinecap="round" />
      <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
      <path d="M9.9 5.1A10.7 10.7 0 0 1 12 5c5 0 9.3 3.4 10.5 8-0.4 1.5-1.2 2.9-2.2 4" strokeLinecap="round" />
      <path d="M6.1 6.1C4.2 7.5 2.8 9.5 1.5 12c1.3 4.6 5.5 8 10.5 8 1.1 0 2.1-0.2 3.1-0.5" strokeLinecap="round" />
    </svg>
  );
}

function IconEye() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function IconArrowRight() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden>
      <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconLockSmall() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <rect x="6" y="11" width="12" height="9" rx="2" />
      <path d="M9 11V8a3 3 0 0 1 6 0v3" strokeLinecap="round" />
    </svg>
  );
}

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials: "include",
      }).then((response) => response.json());

      if (result.status === 200) {
        navigate("/dashboard");
      } else {
        setError(result.message || "Invalid email or password.");
      }
    } catch {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__bg" aria-hidden>
        <span className="admin-login__bg-dots admin-login__bg-dots--tr" />
        <span className="admin-login__bg-dots admin-login__bg-dots--bl" />
        <span className="admin-login__bg-wave admin-login__bg-wave--tr" />
        <span className="admin-login__bg-wave admin-login__bg-wave--bl" />
      </div>

      <div className="admin-login__card">
        <header className="admin-login__brand">
          <span className="admin-login__logo" aria-hidden>
            P
          </span>
          <h1 className="admin-login__title">Portfolio Admin</h1>
          <p className="admin-login__subtitle">Welcome back! Please login to continue</p>
        </header>

        <form className="admin-login__form" onSubmit={handleSubmit} noValidate>
          <div className="admin-login__field">
            <label htmlFor="admin-login-email">Email</label>
            <div className="admin-login__input-wrap">
              <span className="admin-login__input-icon" aria-hidden>
                <IconMail />
              </span>
              <input
                id="admin-login-email"
                className="admin-login__input"
                type="email"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="admin-login__field">
            <label htmlFor="admin-login-password">Password</label>
            <div className="admin-login__input-wrap">
              <span className="admin-login__input-icon" aria-hidden>
                <IconLock />
              </span>
              <input
                id="admin-login-password"
                className="admin-login__input admin-login__input--password"
                type={showPassword ? "text" : "password"}
                name="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="admin-login__toggle-pw"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <IconEye /> : <IconEyeOff />}
              </button>
            </div>
          </div>

          {error ? (
            <p className="admin-login__error" role="alert">
              {error}
            </p>
          ) : null}

          <button type="submit" className="admin-login__submit" disabled={loading}>
            {loading ? "Logging in…" : "Login"}
            {!loading ? <IconArrowRight /> : null}
          </button>
        </form>

        <p className="admin-login__footer">
          <IconLockSmall />
          <span>Secure login • Your data is protected</span>
        </p>
      </div>
    </div>
  );
}

export default Login;
